import { render } from "./AdminTpsScreening.vue?vue&type=template&id=7bdc60e2&scoped=true"
import script from "./AdminTpsScreening.vue?vue&type=script&lang=js"
export * from "./AdminTpsScreening.vue?vue&type=script&lang=js"

import "./AdminTpsScreening.vue?vue&type=style&index=0&id=7bdc60e2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7bdc60e2"]])

export default __exports__